import React, { useMemo } from 'react';
import T from 'prop-types';
import { without } from 'lodash-es';

import { collectionLastLevelOptionsByNodes } from '../utils';

const SelectedList = ({ options, selected, onSelectionChange }) => {
  const mapLastLevelOptionsByNodes = useMemo(
    () => new Map(collectionLastLevelOptionsByNodes(options)),
    [options]
  );

  const selectedOptions = useMemo(() => {
    let restSelected = selected;
    const nextSelectedOptions = [];

    mapLastLevelOptionsByNodes.forEach((lastLevelValues, value_text) => {
      if (restSelected.length && lastLevelValues.every((value) => restSelected.includes(value))) {
        restSelected = restSelected.filter((value) => !lastLevelValues.includes(value));
        const [value, text] = value_text.split('_');
        nextSelectedOptions.push({ value, text });
      }
    });

    return nextSelectedOptions;
  }, [mapLastLevelOptionsByNodes, selected]);

  const handleUnselectOption = ({ value, text }) => {
    const deselectedValues = mapLastLevelOptionsByNodes.get(`${value}_${text}`);
    onSelectionChange(without(selected, ...deselectedValues));
  };

  return (
    <div className="nested-selected-list">
      {selectedOptions.map((option) => (
        <div key={option.value} className="nested-selected-list-item">
          <i className="hicon-close" onClick={() => handleUnselectOption(option)} />
          {option.text}
        </div>
      ))}
    </div>
  );
};

SelectedList.propTypes = {
  options: T.array.isRequired,
  selected: T.array.isRequired,
  onSelectionChange: T.func.isRequired,
};

export default SelectedList;
